import React from "react";
import { Formik, Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import { Button, FormikInput, UploadFile } from "../../../ui";
import { addPropanePopupInitialValues } from "../../../../utils/formik/initialValues";
import {
  addPropanePopupValidationSchema,
  editPropanePopupValidationSchema,
} from "../../../../utils/formik/validationSchema";
import styles from "../addNewLocationForm/style.module.scss";

const AddNewPropanePopupForm = (props) => {
  const isEditing = !!props.formInitialValues;
  const navigate = useNavigate();

  // Debug logging
  console.log("Form mode:", isEditing ? "EDITING" : "CREATING");
  console.log("Form initial values:", props.formInitialValues);
  console.log(
    "Using validation schema:",
    isEditing
      ? "editPropanePopupValidationSchema"
      : "addPropanePopupValidationSchema"
  );

  const handleCancel = () => {
    navigate("/dashboard/propane-popup");
  };

  return (
    <Formik
      initialValues={props.formInitialValues || addPropanePopupInitialValues}
      validationSchema={
        isEditing
          ? editPropanePopupValidationSchema
          : addPropanePopupValidationSchema
      }
      enableReinitialize={true}
      onSubmit={(values) => {
        if (props.formInitialValues) {
          const updatedDataObj = {};
          const keys = Object.keys(props.formInitialValues);
          keys.map((key) => {
            if (props.formInitialValues[key] !== values[key]) {
              return (updatedDataObj[key] = values[key]);
            }
            return false;
          });
          props.updateData({ ...updatedDataObj, id: values.id });
        } else {
          props.data(values);
          console.log("send", values);
        }
      }}
    >
      {({
        errors,
        touched,
        getFieldProps,
        setFieldValue,
        values,
        handleBlur,
      }) => (
        <Form className={styles.addLocationForm}>
          <section>
            <div>
              <FormikInput
                type="text"
                name="title"
                label="Title"
                placeholder="Enter popup title"
                formikProps={getFieldProps("title")}
                formikTouch={touched.title}
                formikErrors={errors.title}
                style={
                  touched.title && errors.title ? { borderColor: "red" } : null
                }
              />
            </div>
            <div>
              <FormikInput
                type="text"
                name="caption"
                label="Caption"
                placeholder="Enter popup caption (max 100 characters)"
                formikProps={getFieldProps("caption")}
                formikTouch={touched.caption}
                formikErrors={errors.caption}
                style={
                  touched.caption && errors.caption
                    ? { borderColor: "red" }
                    : null
                }
              />
            </div>
            <div>
              <UploadFile
                label="Popup Image"
                name="image"
                onChange={(e) => {
                  setFieldValue("image", e.currentTarget.files[0]);
                  handleBlur(e); // Mark field as touched
                }}
                formikTouch={touched.image}
                formikErrors={errors.image}
                style={
                  touched.image && errors.image ? { borderColor: "red" } : null
                }
              />
            </div>
            <div>
              <FormikInput
                type="text"
                name="link"
                label="Link"
                formikProps={getFieldProps("link")}
                formikTouch={touched.link}
                formikErrors={errors.link}
                style={
                  touched.link && errors.link ? { borderColor: "red" } : null
                }
              />
            </div>
            <div
              className={`${styles.bottomRow} ${
                isEditing ? styles.editForm : ""
              }`}
            >
              {/* Active toggle - only visible when editing */}
              {isEditing && (
                <div className={styles.activeToggleContainer}>
                  <label className={styles.toggleLabel}>
                    <Field type="checkbox" name="active" />
                    <span className={styles.toggleSlider}></span>
                    <span className={styles.toggleText}>Active</span>
                  </label>
                </div>
              )}

              <div>
                <Button
                  type="submit"
                  label={props.loading ? "Saving..." : "Save"}
                  disabled={props.loading}
                  primary
                  style={{ maxWidth: "20rem" }}
                />
                <Button
                  type="button"
                  label="Cancel"
                  disabled={props.loading}
                  onClick={handleCancel}
                  secondary
                  style={{ maxWidth: "20rem" }}
                />
              </div>
            </div>
          </section>
        </Form>
      )}
    </Formik>
  );
};

export default AddNewPropanePopupForm;
